export default __webpack_public_path__ + "static/media/clickunder.3390acce.svg";